import { checkPolicyIsUnfinished, getClosestRenewalDateDays } from 'helpers';

export const getRenewalOverview = (policies) => {
  const renewal = getClosestRenewalDateDays(policies);

  if (Number.isNaN(renewal)) {
    const hasUnfinishedPolicy = policies.find(checkPolicyIsUnfinished);
    if (hasUnfinishedPolicy) {
      return 'Finish setup';
    }

    const hasProcessingPolicy = policies.find(
      R.complement(R.prop('processed')),
    );
    if (hasProcessingPolicy) {
      return 'Processing';
    }
  }

  if (renewal < 0) {
    return 'Overdue';
  }

  return renewal === 0
    ? 'Today'
    : `${renewal || 0} ${renewal === 1 ? 'Day' : 'Days'}`;
};
